import { LAYOUTS, ModalAlignmentEnum, } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from './types';
import { onClosePopup, onContinueJourney, onCopyShareLink, TestAction } from './actions';
import { heightMap } from '../../configs/height';
import { partnerApi, StoreKey } from "../../configs/api";
import { getAppHeader, initializeFirebase } from "../../configs/config";
import { isMobile } from "../../configs/utils";
import SharedPropsService from "../../SharedPropsService";
const _isMobile = isMobile();
export const template = async (label, isFirstTime, borrowerAccountId, applicationId, link, partnerName, partnerInterestRate, height, doesEmailExist, name) => ({
    layout: {
        id: ROUTE.REGISTER_LEADS_SUCCESS,
        type: _isMobile ? LAYOUTS.LIST : LAYOUTS.MODAL,
        style: {
            isPartnerPlatform: true,
            height: heightMap[ROUTE.VOLT_APP],
            alignment: ModalAlignmentEnum.RIGHT,
        },
        widgets: [{ id: 'leadsRegistrationSuccessDC', type: WIDGET.PARTNER_LEADS_REGISTRATION_SUCCESS }],
    },
    datastore: {
        leadsRegistrationSuccessDC: {
            height: height,
            shareLinkAction: {
                type: ACTION.ON_COPY_LINK,
                routeId: ROUTE.REGISTER_LEADS_SUCCESS,
                payload: {
                    partnerName: partnerName,
                    value: link,
                    partnerInterestRate: partnerInterestRate,
                    widgetId: 'ShareViaWhatsAppBtn'
                },
            },
            copyLinkAction: {
                type: ACTION.ON_COPY_LINK,
                routeId: ROUTE.REGISTER_LEADS_SUCCESS,
                payload: {
                    partnerName: partnerName,
                    value: link,
                    partnerInterestRate: partnerInterestRate,
                    widgetId: 'CopyLinkBtn'
                },
            },
            continueLoanApplicationAction: {
                type: ACTION.CONTINUE_JOURNEY,
                routeId: ROUTE.REGISTER_LEADS_SUCCESS,
                payload: {
                    value: borrowerAccountId,
                    doesEmailExist: doesEmailExist
                },
            },
            borrowerApplicationId: borrowerAccountId,
            cancelAction: {
                routeId: ROUTE.REGISTER_LEADS_SUCCESS,
                type: ACTION.CLOSE_POP_UP,
                payload: {}
            },
            userFullName: label,
            shareLink: link,
            partnerInterestRate: partnerInterestRate
        },
    },
});
export const registerLeadsSuccessMF = {
    onLoad: async ({ asyncStorage, network, getHeight }, { updatedApplicationObj, stepResponseObject, user, applicationId, borrowerAccountId, name }) => {
        await initializeFirebase();
        const label = user?.fullName;
        await asyncStorage.set("pljName", label);
        const partnerUser = JSON.parse(await asyncStorage.get(StoreKey.userContext));
        const partnerName = partnerUser.linkedPartnerAccounts[0].partnerName;
        let link = '';
        await network
            .get(`${partnerApi.referralLink}${applicationId}`, {
            headers: await getAppHeader(),
            handleFromMF: true
        }, null, {
            width: heightMap[ROUTE.VOLT_APP]
        })
            .then(async (res) => {
            if (res.status === 200) {
                link = res.data.link;
            }
        });
        const doesEmailExist = user?.emailId;
        const isFirstTime = updatedApplicationObj && stepResponseObject ? true : false;
        const partnerInterestRate = await SharedPropsService.getFirebaseConfig()?.partner_interest_rate;
        return Promise.resolve(template(label, isFirstTime, borrowerAccountId, applicationId, link, partnerName, partnerInterestRate, getHeight(), doesEmailExist, name));
    },
    actions: {
        [ACTION.TEST_ACTION]: TestAction,
        [ACTION.CLOSE_POP_UP]: onClosePopup,
        [ACTION.CONTINUE_JOURNEY]: onContinueJourney,
        [ACTION.ON_COPY_LINK]: onCopyShareLink
    },
};
